import { render, staticRenderFns } from "./teaching-activities.vue?vue&type=template&id=91b1f404"
import script from "./teaching-activities.ts?vue&type=script&lang=ts&external"
export * from "./teaching-activities.ts?vue&type=script&lang=ts&external"
import style0 from "./teaching-activities.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports